var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccesinterdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5,2.8l-10,17.3C1.3,20.5,1.5,21,2,21h20c0.4,0,0.7-0.5,0.5-0.9l-10-17.3C12.3,2.5,11.7,2.5,11.5,2.8z M12,6l7.5,13H4.5 L12,6z M11,11v2c0,0.6,0.4,1,1,1h0c0.6,0,1-0.4,1-1v-2c0-0.6-0.4-1-1-1h0C11.4,10,11,10.4,11,11z M11,17L11,17c0,0.6,0.4,1,1,1h0 c0.6,0,1-0.4,1-1v0c0-0.6-0.4-1-1-1h0C11.4,16,11,16.4,11,17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesinterdit);
export default __webpack_public_path__ + "static/media/accesinterdit.77d71f5c25044ed2b0e0195d720ba4f8.svg";
export { ForwardRef as ReactComponent };